// extracted by mini-css-extract-plugin
export default {"facebook":"Contacts_facebook__bV-+9","twitter":"Contacts_twitter__dGBm7","linkedin":"Contacts_linkedin__9tOqa","github":"Contacts_github__u9Hm5","sendBtn":"Contacts_sendBtn__OFi36"};